// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__iT9Xy","title":"Contact_title__7IJ+O","wrapper":"Contact_wrapper__qRxpf","b":"Contact_b__J8hSr","info":"Contact_info__M89cU","icon":"Contact_icon__d70oz"};